import { NetworkService } from "../network.service";

export function getNetworkServiceInstance(): NetworkService | null {
    const networkService = NetworkService.instance;
    if (!networkService) {
        console.error(`🚨 NetworkService is not initialized! Make sure it's provided in root.`);
        return null;
    }
    return networkService;
}